"use client";
import { useEffect, useState } from "react";
import SnackbarComponent from "@/components/Snackbar";
import ModalComponent from "@/components/Modal";
import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import NoInternetSVG from "../NoInternet";

export default function NetworkStatusWrapper({ children }) {
  const theme = useTheme();
  const [showOfflineModal, setShowOfflineModal] = useState(false);
  const isBelowMd = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    function handleOffline() {
      setShowOfflineModal(true);
      SnackbarComponent({
        error: true,
        errorMessage:
          "No internet connection. Please check your network and try again.",
      });
    }
    function handleOnline() {
      setShowOfflineModal(false);
      SnackbarComponent({
        success: true,
        successMessage: "You are back online!",
      });
    }
    if (!navigator.onLine) {
      handleOffline();
    }
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);
  return (
    <>
      <ModalComponent
        open={showOfflineModal}
        handleModal={() => {}}
        closeButtonRequired={false}
      >
        <Stack style={{ padding: 16, alignItems: "center" }}>
          {/* Use the SVG component directly for offline illustration to avoid network fetch and preload warnings */}
          <NoInternetSVG
            style={{
              width: isBelowMd ? 220 : 340,
              height: isBelowMd ? 220 : 340,
              objectFit: "contain",
              display: "block",
            }}
          />
          <Typography
            align="center"
            variant="h6"
            fontWeight={"bold"}
            style={{ marginTop: 16, color: WEB_COLORS.primary }}
          >
            Oops! It looks like {"you're"} offline
          </Typography>
          <Typography
            align="center"
            variant="subtitle1"
            style={{ marginTop: 8 }}
          >
            Please check your internet connection and try again. Once{" "}
            {"you're "}
            back online, everything will load as expected.
          </Typography>
        </Stack>
      </ModalComponent>
      {children}
    </>
  );
}
